import Input from '../../input';
import { IconSearch } from '../../icon';
import BevSafeText from '../../bev-safe-text';

interface TableSearchProps {
	tableId: string;
	searchTerm: string;
	onSearchChange: (value: string) => void;
	placeholder?: string;
	resultsLabel?: string;
	showResultsText?: boolean;
}

export default function TableSearch({
	tableId,
	searchTerm,
	onSearchChange,
	placeholder = 'Search',
	resultsLabel,
	showResultsText = true,
}: TableSearchProps) {
	const searchId = `${tableId}-search`;

	return (
		<div className="flex flex-col spacing-stack-l">
			<Input
				id={searchId}
				type="text"
				value={searchTerm}
				onChange={e => onSearchChange(e.target.value)}
				placeholder={placeholder}
				label={placeholder}
				autoComplete="off"
				aria-controls={tableId}
				icon={<IconSearch width={20} height={20} fill="currentColor" />}
				className="min-w-0 truncate overflow-hidden text-ellipsis whitespace-nowrap !border-border-strong pr-[48px]"
				wrapperClassName="w-full lg:max-w-[615px] !pb-[6px]"
			/>
			{showResultsText && resultsLabel ? (
				<div className="flex w-full justify-end border-t border-border-subtle">
					<p className="py-[6px] text-label text-text-disabled">
						<BevSafeText>{resultsLabel}</BevSafeText>
					</p>
				</div>
			) : null}
		</div>
	);
}
